import {StyleSheet} from "react-native";

export enum Color {
    Background = "#111111",
    Yellow = "#EEDD77",
    Green = "#66DD99",
    Red = "#DD4455",
    BackgroundContainer = "#202020",
    Container = "#404040",
    Faded = "#404040",
    PrimaryText = "#F6F6F6",
    SecondaryText = "#BBBBBB",
    FadedText = "#808080",
    BorderStrong = "#BBBBBB",
}

// Alternate row colors based on alpha channel value.
export function rowColor(baseColor: string, index: number): string {
    return baseColor + (index % 2 === 0 ? '4c' : '26');
}

export const styles = StyleSheet.create({
    header: {
        color: Color.PrimaryText,
        fontSize: 24,
        width: "100%",
    },
    text: {
        color: Color.PrimaryText,
        fontSize: 16,
        width: "100%",
    },
    error: {
        color: Color.Red,
        width: "100%",
        fontSize: 16,
    },
    link: {
        color: Color.Yellow,
        fontSize: 16,
        textDecorationLine: "underline",
    },
    textInput: {
        width: 322,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: Color.Yellow,
        borderRadius: 7,
        padding: 8,
        fontSize: 16,
        color: Color.PrimaryText,
    },
})